import { FC, ReactNode } from 'react';

import { Card, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import styles from 'components/common/MagritteBannerPreviewSidebar/Banner/Banner.module.less';

interface BannerProps {
    image: string;
    title: string;
    text: string;
    bannerImageBadge?: ReactNode;
}

const TrlKeys = {
    BannerPreviewDefaultTitle: 'create.campaign.preview.banner.default.title',
    BannerPreviewDefaultText: 'create.campaign.preview.banner.default.text',
};

export const Banner: FC<BannerProps> = ({ image, title, text, bannerImageBadge }) => {
    const trls = useTrls();

    return (
        <Card padding={24} borderRadius={24} style="secondary" stretched data-qa="magritte-banner-preview">
            <div className={styles.content}>
                <div className={styles.textWrapper}>
                    <Text typography="subtitle-1-semibold" data-qa="magritte-banner-preview-title">
                        {title || trls(TrlKeys.BannerPreviewDefaultTitle)}
                    </Text>
                    <Text typography="label-3-regular" data-qa="magritte-banner-preview-text">
                        {text || trls(TrlKeys.BannerPreviewDefaultText)}
                    </Text>
                </div>
                <div className={styles.imageWrapper}>
                    <img src={image} className={styles.image} data-qa="magritte-banner-preview-image" />
                    {bannerImageBadge && <div className={styles.generatedImageResetIcon}>{bannerImageBadge}</div>}
                </div>
            </div>
        </Card>
    );
};
